/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getObstetricEvents } from 'app/entities/obstetric-event/obstetric-event.reducer';
import { getEntities as getPregnancyCases } from 'app/entities/pregnancy-case/pregnancy-case.reducer';
import { getEntities as getAdmissions } from 'app/entities/admission/admission.reducer';
import { getEntities as getReferrals } from 'app/entities/referral/referral.reducer';
import { createEntity, getEntity, reset, updateEntity } from './labor-incident.reducer';

export const LaborIncidentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const obstetricEvents = useAppSelector(state => state.obstetricEvent.entities);
  const pregnancyCases = useAppSelector(state => state.pregnancyCase.entities);
  const admissions = useAppSelector(state => state.admission.entities);
  const referrals = useAppSelector(state => state.referral.entities);
  const laborIncidentEntity = useAppSelector(state => state.laborIncident.entity);
  const loading = useAppSelector(state => state.laborIncident.loading);
  const updating = useAppSelector(state => state.laborIncident.updating);
  const updateSuccess = useAppSelector(state => state.laborIncident.updateSuccess);

  const handleClose = () => {
    navigate(`/labor-incident${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getObstetricEvents({}));
    dispatch(getPregnancyCases({}));
    dispatch(getAdmissions({}));
    dispatch(getReferrals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.laborCompleteTime !== undefined && typeof values.laborCompleteTime !== 'number') {
      values.laborCompleteTime = Number(values.laborCompleteTime);
    }

    const entity = {
      ...laborIncidentEntity,
      ...values,
      obstetricEvent: obstetricEvents.find(it => it.id.toString() === values.obstetricEvent?.toString()),
      pregnancy: pregnancyCases.find(it => it.id.toString() === values.pregnancy?.toString()),
      admission: admissions.find(it => it.id.toString() === values.admission?.toString()),
      referral: referrals.find(it => it.id.toString() === values.referral?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...laborIncidentEntity,
          obstetricEvent: laborIncidentEntity?.obstetricEvent?.id,
          pregnancy: laborIncidentEntity?.pregnancy?.id,
          admission: laborIncidentEntity?.admission?.id,
          referral: laborIncidentEntity?.referral?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.laborIncident.home.createOrEditLabel" data-cy="LaborIncidentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.laborIncident.home.createOrEditLabel">Create or edit a LaborIncident</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="labor-incident-id"
                  label={translate('tinyMedicRestApp.laborIncident.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.laborIncident.validLabor')}
                id="labor-incident-validLabor"
                name="validLabor"
                data-cy="validLabor"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.laborIncident.active')}
                id="labor-incident-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.laborIncident.cursor')}
                id="labor-incident-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.laborIncident.lastUpdated')}
                id="labor-incident-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.laborIncident.microSec')}
                id="labor-incident-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.laborIncident.timestampEntry')}
                id="labor-incident-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.laborIncident.expose')}
                id="labor-incident-expose"
                name="expose"
                data-cy="expose"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.laborIncident.laborComplete')}
                id="labor-incident-laborComplete"
                name="laborComplete"
                data-cy="laborComplete"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.laborIncident.laborCompleteTime')}
                id="labor-incident-laborCompleteTime"
                name="laborCompleteTime"
                data-cy="laborCompleteTime"
                type="text"
              />
              <ValidatedField
                id="labor-incident-obstetricEvent"
                name="obstetricEvent"
                data-cy="obstetricEvent"
                label={translate('tinyMedicRestApp.laborIncident.obstetricEvent')}
                type="select"
              >
                <option value="" key="0" />
                {obstetricEvents
                  ? obstetricEvents.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="labor-incident-pregnancy"
                name="pregnancy"
                data-cy="pregnancy"
                label={translate('tinyMedicRestApp.laborIncident.pregnancy')}
                type="select"
              >
                <option value="" key="0" />
                {pregnancyCases
                  ? pregnancyCases.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="labor-incident-admission"
                name="admission"
                data-cy="admission"
                label={translate('tinyMedicRestApp.laborIncident.admission')}
                type="select"
              >
                <option value="" key="0" />
                {admissions
                  ? admissions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="labor-incident-referral"
                name="referral"
                data-cy="referral"
                label={translate('tinyMedicRestApp.laborIncident.referral')}
                type="select"
              >
                <option value="" key="0" />
                {referrals
                  ? referrals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/labor-incident" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LaborIncidentUpdate;
